/* eslint-disable */
import React from 'react';
import './help.style.scss';
/**
 * Representing the help component.
 * @extends Component
 * */
function Help() {
  return (
    <div className="help-section container">
      <h2>Help</h2>
      <h5>System Requirements:</h5>
      <p>Please use this website in the Chrome™ or Safari® browser. Other web browsers are not supported at this time. iPhone® use requires iOS® 13 or greater. </p>
      <h5>Microphone Permissions:</h5>
      <p>You will need to make sure the web browser has permission to use your microphone. For iOS 13 or greater, select AA from the left side of the address bar. Select Website Settings, then change/verify that Microphone is set to Allow. </p>
      <h5>General Use: </h5>
      <p>Use this Message Banking website to record messages you would like to import into your communication software. If you experience unexpected behavior while using the website, try refreshing your browser. If the behavior persists, see below for additional support options.</p>
      <p><strong>Recording and Tagging Messages</strong></p>
      <ul><li>Use the Record button on the bottom of the home screen to make a new recording. </li>
        <li>Tap the green Record button to start the recording. </li>
        <li>Tap the red Stop button to stop the recording. </li>
        <li>Once you have created a recording, you can Play, Retry, Cancel, or Save it.</li>
        <li>Once saved, you can Title, Play, Transcribe, and/or Tag the recording. </li>
          <ul><li>The transcription will be used as the message that appears in the message window of your communication software. If no transcription is provided, the title will be used. </li>
            <li>The tags will be used to create different pages within your communication software such as Wants/Needs, Greetings, Questions etc. </li></ul>
        <li>Use the Back Arrow next to the Title of your recording to return to your list of recordings. </li></ul>
      <p><strong>Managing Messages</strong></p>
      <ul><li>From your list of recordings, you can Select individual files or Select All files to Download or Delete. These options are found at the bottom of the screen. </li>
      <li>Once downloaded, a zip file will be generated. </li>
      <li>This zip file can then be imported into your communication software. Please refer to the User’s Guide of your communication software for more details.</li>
      <li>Once you have imported the zip file into your communication software, you will be able to use your recordings to communicate. </li></ul>
      <h5>Additional Support: </h5>
      <p>For help with this message banking website please email service@prentrom.com.
      <br />For more information about communication devices and apps from PRC-Saltillo please visit <a href="https://www.prc-saltillo.com/" target="_blank">prc-saltillo.com.</a> </p>
      <br />
      <br />
    </div>
  );
}
export default Help;



// WEBPACK FOOTER //
// ./src/messages/help/help.component.js